import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import * as utils from '../../utils/utility-functions';
import { AppointmentCollectionService } from "./appointment-collection.service";
import { Doctor } from "src/app/models/doctor.model";
import { AngularFirestore, AngularFirestoreCollection } from "@angular/fire/compat/firestore";

@Injectable({
  providedIn: 'root',
})
export class DoctorService {
  private firebaseDoctorCollection: AngularFirestoreCollection;

  private currentUser: any;

  private doctor = new BehaviorSubject<Doctor>(new Doctor());
  currentDoctor = this.doctor.asObservable();

  constructor(
    private appointmentService: AppointmentCollectionService,
    private angularFirestore: AngularFirestore) {
  }


  async getDoctorInformation(userID: string) {
    try {
      let doctor = null;

      if (this.firebaseDoctorCollection == null) {
        this.firebaseDoctorCollection = this.angularFirestore.collection('Doctors');
      }

      await this.firebaseDoctorCollection.ref
        .doc(userID)
        .get()
        .then(querySnapshot => {
          const docData = {
            id: querySnapshot.id,
            ...querySnapshot.data()
          }
          doctor = docData;
        }).catch(err => console.log("getDoctorInformation query 1 error: " + err));

      this.updateDoctor(doctor);
      return doctor;
    } catch (error) {
      console.log('getDoctorInformation(): ' + JSON.stringify(error));
    }
  }

  async getDoctorByUserID() {
    try {
      let doctor = null;

      if (this.firebaseDoctorCollection == null) {
        this.firebaseDoctorCollection = this.angularFirestore.collection('Doctors');
      }

      await this.firebaseDoctorCollection.ref
        .doc(this.currentUser.id)
        .get()
        .then(querySnapshot => {
          const docData = {
            id: querySnapshot.id,
            ...querySnapshot.data()
          }
          doctor = docData;
        }).catch(err => console.log("getDoctorByID query 1 error: " + err));

      this.updateDoctor(doctor);
      return doctor;
    } catch (error) {
      console.log('getDoctorByUserID(): ' + JSON.stringify(error));
    }
  }

  async getDoctorByID(id: string) {
    try {
      let doctor = null;

      if (this.firebaseDoctorCollection == null) {
        this.firebaseDoctorCollection = this.angularFirestore.collection('Doctors');
      }

      await this.firebaseDoctorCollection.ref
        .doc(id)
        .get()
        .then(querySnapshot => {
          const docData = {
            id: querySnapshot.id,
            ...querySnapshot.data()
          }
          doctor = docData;
        }).catch(err => console.log("getDoctorByID query 1 error: " + err));

      this.updateDoctor(doctor);
      return doctor;
    } catch (error) {
      console.log('getDoctorByID(): ' + JSON.stringify(error));
    }
  }

  setUser(currentUser: any) {
    this.currentUser = currentUser;
    this.getDoctorByUserID();
  }

  updateDoctor(doctor: any) {
    const doctorUser = utils.createDoctorObject(doctor);
    localStorage.setItem('doctorUser', JSON.stringify(doctorUser));

    let newDoctor = utils.createDoctor(doctor);
    this.appointmentService.setUser(newDoctor);
    this.doctor.next(newDoctor);
  }
}